import { createFileRoute } from "@tanstack/react-router";
import { RunsList, type RunsSearch } from "../../features/runs/runs-list";

const TABS = ["failed", "active", "history", "all", "gpus"] as const;
// Listed here rather than imported, so search validation keeps the list's module out of the initial bundle.
const VIEWS = ["pretraining", "posttraining", "finetuning"] as const;

export const Route = createFileRoute("/_authed/$org/$project/runs")({
  validateSearch: (s: Record<string, unknown>): RunsSearch => ({
    ...(TABS.includes(s.tab as never) ? { tab: s.tab as RunsSearch["tab"] } : {}),
    ...(VIEWS.includes(s.view as never) ? { view: s.view as RunsSearch["view"] } : {}),
    ...(typeof s.kind === "string" ? { kind: s.kind } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
    ...(s.children === true || s.children === "true" ? { children: true } : {}),
    ...(typeof s.by === "string" && s.by ? { by: s.by } : {}),
  }),
  component: RunsPage,
});

function RunsPage() {
  const { org, project } = Route.useParams();
  return <RunsList scope={{ org, project }} search={Route.useSearch()} />;
}
